export default __webpack_public_path__ + "static/media/pokeball-gray.1de67fd7.svg";